import { Box, Collapse, FormControlLabel, Radio, Typography } from '@mui/material'
import { SurveyTextField } from '../components/SurveyTextField'
import { SurveyFileDisplay } from '../components/SurveyFileDisplay'
import { DragAndDropFilePicker } from '../../../DragAndDropFilePicker'
import { InvoicingInstruction } from './InvoicingInstruction'
import { styles } from './styles'
import { type MappedChoice } from './types'
import { type SurveyRadio } from './SurveyRadioModel'

interface Props {
  choice: MappedChoice
  isSelected: boolean
  question: SurveyRadio
  onDeleteFile: () => void
  uploadedFileName: string | null
  uploadedFileKey: string | null
}

export const SurveyRadioChoice = ({
  choice,
  isSelected,
  question,
  onDeleteFile,
  uploadedFileName,
  uploadedFileKey
}: Props): JSX.Element => {
  const showInvoicingInstructions = question.name === 'rcn_invoicing_start' && choice.value === 'Yes'

  return (
    <Box sx={styles.choiceContainer}>
      <FormControlLabel
        data-testid={`${choice.value}`}
        value={choice.value}
        control={<Radio />}
        label={choice.text}
      />
      <Collapse in={isSelected && choice.infoText !== ''}>
        <Typography variant="body1" sx={styles.infoText}>
          {choice.infoText}
        </Typography>
      </Collapse>
      <Collapse in={isSelected && choice.hasTextArea}>
        <Box sx={styles.textFieldWrapper}>
          <SurveyTextField
            value={question.extraInfo ?? ''}
            onChange={(e) => { question.extraInfo = e.target.value }}
            placeholder="Add details here"
            data-testid={`${question.name}_extraInfo`}
          />
        </Box>
      </Collapse>
      <Collapse in={isSelected && choice.hasUpload}>
        <Box >
          {showInvoicingInstructions && <InvoicingInstruction />}
          <Box sx={styles.filePickerWrapper}>
            <DragAndDropFilePicker
              selectFile={(file) => { question.handleFileSelect(file) }}
              accept=".pdf,.jpg,.jpeg,.doc,.xlsx,.csv,.docx"
              useButton
            />
          </Box>
          <SurveyFileDisplay
            fileName={uploadedFileName}
            fileKey={uploadedFileKey}
            onDelete={onDeleteFile}
          />
        </Box>
      </Collapse>
    </Box>
  )
}
